import React from 'react'
import ClusterScopetab from './ClusterScopetab'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import UserMenu from './UserMenu'
import style from './style.module.scss'
import { Tooltip, Affix } from 'antd'
import NotesComp from 'components/common/Notes'
import Common from 'services/common'

const mapStateToProps = ({ menu, settings, user }) => ({
  isMenuCollapsed: settings.isMenuCollapsed,
  licenseType: user.licenseType,
})

@withRouter
@connect(mapStateToProps)
class TopBar extends React.Component {
  state = {
    MenuFlag: null,
    active: false,
    showNotes: false,
    licenseType: this.props.licenseType,
    clusterId: null,
    scopeId: null,
    urlParams: {},
  }

  UNSAFE_componentWillMount() {
    this.setState({ MenuFlag: this.props.isMenuCollapsed })

    // this.setSelectedKeys(this.props)
    let url_break = this.props.location.pathname.split('/')
    this.setState(
      {
        clusterId: url_break[1],
        scopeId: url_break[2],
      },
      () => {
        this.makeParams()
      },
    )
  }

  makeParams = () => {
    let url_params = {
      clusterId: this.state.clusterId,
      scopeId: this.state.scopeId,
    }
    this.setState({
      urlParams: url_params,
    })
  }

  onCollapse = (value, type) => {
    const { dispatch, isMenuCollapsed } = this.props
    if (type === 'responsive' && isMenuCollapsed) {
      return
    }

    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'isMenuCollapsed',
        value: !isMenuCollapsed,
      },
    })
    this.setState({ MenuFlag: !isMenuCollapsed })
  }
  toggleClass = () => {
    const currentState = this.state.active
    this.setState({ active: !currentState })
    this.onCollapse()
  }

  closePanel = () => {
    this.setState({ showNotes: false })
  }
  render() {
    return (
      <>
        {!window.location.toString().includes('/reportlink/') && (
          <Affix>
            <div className={style.topbar}>
              {/* <div className={style.menuToggIcon}>
              {Common.decryptData(localStorage.getItem('UserAcc'), true) === 'User - No Access' ||
                Common.decryptData(localStorage.getItem('UserAcc'), true) === 'Admin - No Access' ? null : this.state
                    .MenuFlag ? (
                  <i
                    style={{
                      position: 'relative',

                      fontSize: '1rem',
                      cursor: 'pointer',
                    }}
                    onClick={this.onCollapse}
                    className="fal fa-bars"
                    aria-hidden="true"
                  ></i>
                ) : (
                  <i
                    style={{
                      position: 'relative',

                      fontSize: '1rem',
                      cursor: 'pointer',
                    }}
                    data-fa-transform="rotate-90"
                    onClick={this.onCollapse}
                    className="fal fa-bars fa-rotate-90"
                    aria-hidden="true"
                  ></i>
                )} 
              </div> */}
              <div className="mr-auto">
                {!(
                  window.location.toString().includes('admin/clusters') ||
                  // window.location.toString().includes('admin/global') ||
                  window.location.toString().includes('admin/user') ||
                  window.location.toString().includes('admin/smtp')
                ) ? (
                  Common.decryptData(localStorage.getItem('UserAcc'), true) === 'User - No Access' ? null : (
                    <span>
                      DNIF HYPERSCALE {this.state.licenseType ? this.state.licenseType.toUpperCase() : ''}
                    </span>
                  )
                ) : null}
                {/* <span
            style={{
              color: '#adc6ff',
              background: '#232135',
              border: '1px solid #2f54eb',
              fontSize: '0.6rem',
              padding: '0px 3px',
              borderRadius: '2px',
              marginLeft: '8px',
            }}
            className={'consoleTagStyle'}
          >
            beta
          </span> */}
                {/* <Breadcrumbs style={{ padding: '0px' }} /> */}
              </div>
              {!(
                window.location.toString().includes('admin/clusters') ||
                // window.location.toString().includes('admin/global') ||
                window.location.toString().includes('admin/user') ||
                window.location.toString().includes('admin/smtp')
              ) && (
                  <div
                    className="d-none d-md-block"
                    style={{ marginRight: !(['User - No Access', 'Admin - No Access', 'Admin - Viewer', 'User - Viewer'].includes(Common.decryptData(localStorage.getItem('UserAcc'), true))) ? '0' : '-18px' }}
                  >
                    <ClusterScopetab />
                  </div>
                )}
              { }

              {!(
                window.location.toString().includes('admin/clusters') ||
                // window.location.toString().includes('admin/global') ||
                window.location.toString().includes('admin/user') ||
                window.location.toString().includes('admin/components') ||
                window.location.toString().includes('admin/smtp') ||
                window.location.toString().includes('admin/switchboard')
              ) && (
                  <div style={{ padding: '8px 0px 10px 8px' }} className="">
                    {Common.decryptData(localStorage.getItem('UserAcc'), true) !== 'User - No Access' &&
                      Common.decryptData(localStorage.getItem('UserAcc'), true) !== 'Admin - No Access' &&
                      Common.decryptData(localStorage.getItem('UserAcc'), true) !== 'Admin - Viewer' &&
                      Common.decryptData(localStorage.getItem('UserAcc'), true) !== 'User - Viewer' ? (
                      <Tooltip title="Notes">
                        <span
                          className={style.HoverIcon}
                          onClick={() => {
                            this.setState({ showNotes: true })
                          }}
                        >
                          <i className="fal fa-comment-alt"></i>
                        </span>
                      </Tooltip>
                    ) : null}
                  </div>
                )}
              <div style={{ padding: '8px 1px 10px 8px' }} className="">
                <UserMenu />
              </div>
              {this.state.showNotes ? (
                <NotesComp
                  visible={this.state.showNotes}
                  setPanelVisibility={this.closePanel}
                  type={'drawer'}
                  urlData={this.state.urlParams}
                />
              ) : null}
            </div>
          </Affix>
        )}{' '}
      </>
    )
  }
}

export default withRouter(TopBar)
